<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mfJDBD/tc-custom/9781480474239.jpg?1705692044648" alt="This image is the cover for the book Mistress of Night and Dawn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mistress of Night and Dawn
      </h1>
      <p class="bookDescription body article font2">
        <b>From international bestselling author Vina Jackson comes the seductive story of a love affair that spans the globe</b><br/>Growing up, Aurelia was haunted by the mysterious death of her parents when she was very young, and she has always longed to know the truth about her past. At eighteen, she meets a man who will change her life forever, and when he disappears before she can learn his name, she vows to find him again.<br/>Thanks to an unknown benefactor, Aurelia travels to America to continue her education. There she comes across the existence of an exclusive ball that has been held every year for centuries. The decadent celebration of the senses travels from country to country, cropping up in secret locations and including only a very selective list of guests.<br/>Caught up in a world of passion and intrigue, Aurelia soon becomes one of the ball’s star attractions. But little does she know that as her involvement with the festivities increases, she is coming ever closer to discovering the truth about her mysterious benefactor, her own past, and the identity of the one man she has ever truly loved.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vina Jackson
      </h2>
      
      <p class="authorDescription body article">Vina Jackson is the pseudonym for two established writers working together. One is a successful author; the other is a published writer who is also a financial professional in London.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orion
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e1ef9e8c